module.exports = __webpack_public_path__ + "static/media/Correct.29d1153d.svg";